export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 7_11.4a91e40d.jpg";